module.exports = __webpack_public_path__ + "static/media/femalecodertocat.ec5f1887.png";